import { ReactElement, useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'

import axios from 'src/utilities/http-client'
import { CancelIcon, SubmitIcon } from 'src/v3/core/icons'
import { useAppDispatch } from 'src/store/hooks'

import { fetchNREMTVerificationStatus } from 'src/v3/manage/manage.slice'
import { VerificationStatus } from 'src/v3/core/types'

type VerifyNREMTProps = {
  open: boolean
  setOpen: (status: boolean) => void
  linkedServiceID: string
  userID: string
}

const radioSize = 32

export let VerifyNREMT = ({
  open,
  setOpen,
  linkedServiceID,
  userID,
}: VerifyNREMTProps): ReactElement => {
  let dispatch = useAppDispatch()

  let [decision, setDecision] = useState<VerificationStatus>('accepted')
  let [saving, setSaving] = useState(false)

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Paper sx={{ width: 300, px: 2, py: 1 }}>
        <DialogTitle sx={{ textAlign: 'center', mb: -1 }}>
          Verify NREMT
        </DialogTitle>
        <DialogContent
          sx={{
            px: 2,
            pb: 1,
            display: 'flex',
            gap: 2,
            flexDirection: 'column',
          }}
        >
          <FormControl>
            <Typography
              color="textSecondary"
              id="demo-controlled-radio-buttons-group"
              sx={{ ml: -1, my: 0.5 }}
            >
              Decision
            </Typography>
            <RadioGroup
              aria-labelledby="nremt-validation-decision"
              name="nremt-validation-decision"
              value={decision}
              onChange={(e) =>
                setDecision(e.target.value as VerificationStatus)
              }
            >
              <FormControlLabel
                value="accepted"
                control={<Radio sx={{ height: radioSize, width: radioSize }} />}
                label="Accept"
              />
              <FormControlLabel
                value="rejected"
                control={<Radio sx={{ height: radioSize, width: radioSize }} />}
                label="Reject"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pb: 1.5,
          }}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
            sx={{ flex: '1 1 0px' }}
            startIcon={<SubmitIcon />}
            loading={saving}
            onClick={() => {
              setSaving(true)
              axios
                .post('/api/manage/nremt/verify', {
                  userID,
                  linkedServiceID,
                  status: decision,
                  explanation: undefined,
                })
                .then(() =>
                  dispatch(
                    fetchNREMTVerificationStatus({ userID, linkedServiceID }),
                  ),
                )
                .then(() => setOpen(false))
                .finally(() => setSaving(false))
            }}
          >
            Submit
          </Button>
          <Button
            onClick={() => setOpen(false)}
            color="error"
            variant="contained"
            sx={{ flex: '1 1 0px' }}
            startIcon={<CancelIcon />}
          >
            Cancel
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  )
}
